import { DataGrid } from "@mui/x-data-grid"
import { Box, Typography, Button } from "@mui/material"
import { Add as AddIcon } from "@mui/icons-material"
import { useState } from "react"
import getShipmentStatusColumns from "./getShipmentStatusColumns"
import CreateShipmentStatusDialog from "../../dialog/create-shipment-status-dialog"
import { ModuleEnum, useDeleteUtilityMutation, useGetUtilitiesQuery, Utility } from "src/api/modules/utilitize"

const ShipmentStatusList = () => {
  const [createShipmentStatusDialogOpen, setCreateShipmentStatusDialogOpen] = useState(false)
  const [editShipmentStatus, setEditShipmentStatus] = useState<Utility | null>(null)
  const [deleteShipmentStatus, { isLoading: isDeleteLoading }] = useDeleteUtilityMutation()

  const handleEdit = (shipmentStatus: Utility) => {
    console.log("Edit shipment status:", shipmentStatus)
    setEditShipmentStatus(shipmentStatus)
    setCreateShipmentStatusDialogOpen(true)
  }

  const handleDelete = async (shipmentStatus: Utility) => {
    console.log("Delete shipment status:", shipmentStatus)
    const resp = await deleteShipmentStatus({ id: shipmentStatus.id || "" })
    console.log("resp", resp)
  }

  const shipmentStatusColumns = getShipmentStatusColumns({ handleEdit, handleDelete })
  const { data: shipmentStatusesData, isLoading } = useGetUtilitiesQuery({
    page: 1,
    limit: 10000,
    module: ModuleEnum.SHIPMENT_STATUS
    // active: true
  })

  const handleAdd = () => {
    setCreateShipmentStatusDialogOpen(true)
  }

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          width: "100%",
          p: 2,
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography variant="h5" component="h2">
            Shipment Status Management
          </Typography>
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleAdd}>
            Add Shipment Status
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <DataGrid<Utility>
            density="compact"
            loading={isLoading || isDeleteLoading}
            rows={shipmentStatusesData?.data || []}
            showColumnVerticalBorder
            getRowId={(row) => row.id || ""}
            columns={shipmentStatusColumns}
            pageSizeOptions={[10, 25, 50]}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            disableRowSelectionOnClick
            disableColumnFilter
            disableColumnSorting
            disableColumnMenu
            sx={{
              border: (theme) => `1px solid ${theme.palette.divider}`,
              "& .MuiDataGrid-cell": {
                borderTop: (theme) => `1px solid ${theme.palette.divider}`
              },
              "& .MuiDataGrid-cell:focus": {
                outline: "none"
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "action.hover"
              }
            }}
          />
        </Box>
      </Box>
      <CreateShipmentStatusDialog
        open={createShipmentStatusDialogOpen}
        onClose={() => {
          setCreateShipmentStatusDialogOpen(false)
          setEditShipmentStatus(null)
        }}
        utility={editShipmentStatus || undefined}
      />
    </>
  )
}

export default ShipmentStatusList
